export function imprimirEtiquetasConversion(configuracionLanding, etiquetaVariableConv = 'c_var_10') {
  const etiquetasConversion = configuracionLanding.etiquetas.conversion
  const formularios = document.querySelectorAll('.wg-form')
  console.log(etiquetasConversion)

  for (let [etqId, etqValor] of Object.entries(etiquetasConversion)) {
    const hiddenConv = `<input type="hidden" name="${etqId}" class="wg-cvar" value="${etqValor}" />`
    formularios.forEach((form) => {
      form.innerHTML += hiddenConv
    })
    if (etqId === 'c_var_3') {
      etqValor = 'ringpool'
    }
    if (window.userLabels.EConversion) window.userLabels.EConversion.push({ id: etqId, value: etqValor })
    window[etqId] = etqValor
    const conversionTag = window[etqId]
    console.log({ conversionTag })
  }
  if (window.walmeric !== '') window[etiquetaVariableConv] = window.walmeric
  const conversions = window.userLabels.EConversion
  console.log('Consulta imprimirEtiquetasConversion.js userLabels:', { conversions })
}
